// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box[data-v-79423192]{\n  padding: 10px 25px;\n  border-radius: 10px;\n}\nh3[data-v-79423192]{\n  font-size: 1.5rem;\n}\n.participan-tags[data-v-79423192]{\n  margin: 0.25em 0 1em 0;\n}\n", ""]);
// Exports
module.exports = exports;
